import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getHTTPClient } from 'src/core/services/api/httpClient';
export class RequestService {
  constructor(apiSource) {
    this.httpClient = getHTTPClient(apiSource);
  }
  head(url, config) {
    return this.httpClient.head(url, config);
  }
  get(url, config) {
    return this.httpClient.get(url, _objectSpread(_objectSpread({}, config), {}, {
      // This is workaround for setting "content-type":
      // https://github.com/axios/axios/issues/86,
      data: null
    }));
  }
  post(url, data, config) {
    return this.httpClient.post(url, data, config);
  }
  put(url, data, config) {
    return this.httpClient.put(url, data, config);
  }
  patch(url, data, config) {
    return this.httpClient.patch(url, data, config);
  }
  delete(url, data, config) {
    return this.httpClient.delete(url, _objectSpread(_objectSpread({}, config), {}, {
      // This is workaround for setting "content-type":
      // https://github.com/axios/axios/issues/86
      data: data ? data : null
    }));
  }
  getBaseUrl() {
    return this.httpClient.defaults.baseURL;
  }
}
export const requestService = apiSource => new RequestService(apiSource);